/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { init as initFullStory } from '@fullstory/browser'

import type { FC } from 'react'
import type { StateProps as Props } from './types'

const Tracking: FC<Props> = ({ fullStoryId, isFullStoryEnabled }) => {
  useEffect(() => {
    if (!isFullStoryEnabled && !fullStoryId) {
      return
    }

    window._fs_capture_on_startup = false

    initFullStory({
      orgId: fullStoryId,
      startCaptureManually: true, // this is equivalent to _fs_capture_on_startup
      cookieDomain: '.elastic.co',
    })
  }, [])

  return <Outlet />
}

export default Tracking
